import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import {
  LENNAR_ACCOUNT_ACCESS_ERROR_MESSAGE,
  LENNAR_SERVICE_DESK_CONTACT_INFO,
} from '../constants/plans.constants'

export function HelpPage() {
  return (
    <Grid container>
      <Grid sx={{ marginTop: '24px', width: '100%' }}>
        <Stack alignItems="center">
          <Typography variant="h6" color="inherit">
            {`${LENNAR_ACCOUNT_ACCESS_ERROR_MESSAGE}`}
          </Typography>

          <Typography variant="h6" color="inherit">
            {`${LENNAR_SERVICE_DESK_CONTACT_INFO}`}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  )
}
